import {getAdminToken} from '../../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

function getAuthHeaders(): HeadersInit {
  const token = getAdminToken()
  return token ? {Authorization: `Bearer ${token}`} : {}
}

export interface TrainingRecording {
  _id: string
  title: string
  description: string
  file_url: string
  duration: number
  tags: string[]
  salesperson: string
  rating: number | null
  played: boolean
  played_at: string | null
  notes: string
}

export async function getTrainingRecordings(): Promise<{recordings: TrainingRecording[]}> {
  const response = await fetch(`${API_URL}/admin/sales-library/training`, {
    credentials: 'include',
    headers: getAuthHeaders(),
  })
  if (!response.ok) throw new Error('Failed to fetch training recordings')
  return response.json()
}

export async function markAsPlayed(id: string): Promise<{success: boolean}> {
  const response = await fetch(`${API_URL}/admin/sales-library/training/${id}/played`, {
    method: 'POST',
    credentials: 'include',
    headers: getAuthHeaders(),
  })
  if (!response.ok) throw new Error('Failed to mark as played')
  return response.json()
}

export async function saveNotes(id: string, notes: string): Promise<{success: boolean}> {
  const token = getAdminToken()
  const response = await fetch(`${API_URL}/admin/sales-library/training/${id}/notes`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? {Authorization: `Bearer ${token}`} : {}),
    },
    body: JSON.stringify({notes}),
  })
  if (!response.ok) throw new Error('Failed to save notes')
  return response.json()
}
